import React from "react";
import { createUseStyles } from "react-jss";
import unsafeHTML from "../../../utils/unsafeHTML";
import Button from "../../common/Button";
import Typography from "../../Typography";
var CenterAlign = function (_a) {
    var backgroundImageMobile = _a.backgroundImageMobile, backgroundImageDesktop = _a.backgroundImageDesktop, header = _a.header, subtext = _a.subtext, buttonColor = _a.buttonColor, buttonTextColor = _a.buttonTextColor, buttonLink = _a.buttonLink, buttonTarget = _a.buttonTarget, buttonText = _a.buttonText, headerImage = _a.headerImage, backgroundColor = _a.backgroundColor, textColor = _a.textColor;
    var useStyles = createUseStyles(function (theme) {
        var _a, _b, _c, _d, _e;
        return ({
            root: (_a = {
                    display: "block",
                    position: "relative",
                    width: "100%",
                    height: "auto",
                    margin: "0 auto",
                    backgroundColor: backgroundColor,
                    color: textColor || "inherit"
                },
                _a[theme.mediaQuery(theme.breakpoints.medium)] = {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundImage: function () {
                        return backgroundImageDesktop ? "url(" + backgroundImageDesktop + ")" : "none";
                    },
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                },
                _a),
            container: {
                display: "block",
                padding: "80px 0",
            },
            contentContainer: (_b = {
                    color: textColor || "inherit",
                    lineHeight: "45px",
                    maxWidth: "500px",
                    marginLeft: "auto",
                    marginRight: "auto",
                    display: "block",
                    padding: "0 15px"
                },
                _b[theme.mediaQuery(theme.breakpoints.medium)] = {
                    fontSize: theme.typography.heading2.fontSize,
                    fontWeight: "900",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    lineHeight: "70px",
                    position: "relative",
                    maxWidth: "1100px",
                    textAlign: "center",
                    "& button": (_c = {},
                        _c[theme.mediaQuery(theme.breakpoints.medium)] = {
                            fontSize: 30,
                        },
                        _c),
                },
                _b),
            subText: (_d = {
                    margin: "60px auto",
                    maxWidth: "400px",
                    display: "block",
                    color: textColor || "inherit"
                },
                _d[theme.mediaQuery(theme.breakpoints.medium)] = {
                    fontSize: theme.typography.heading4.fontSize,
                    position: "relative",
                    maxWidth: "700px",
                },
                _d),
            topImage: {
                position: "relative",
                height: "auto",
                maxWidth: "100%",
                padding: "10px 15px",
            },
            styleMobilePicture: (_e = {},
                _e[theme.mediaQuery(theme.breakpoints.medium)] = {
                    display: "none",
                },
                _e.width = "100%",
                _e),
        });
    });
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.container },
            backgroundImageMobile && (React.createElement("img", { "data-testid": "mobileImage", className: classes.styleMobilePicture, src: backgroundImageMobile || undefined, alt: "", role: "presentation" })),
            headerImage && (React.createElement("div", null,
                React.createElement("img", { "data-testid": "headerImage", className: classes.topImage, src: headerImage, alt: "", role: "presentation" }))),
            React.createElement("div", { className: classes.contentContainer },
                React.createElement(Typography, { variant: "heading2", style: { maxWidth: 900 }, dangerouslySetInnerHTML: unsafeHTML(header) }),
                React.createElement(Typography, { className: classes.subText, variant: "heading6", dangerouslySetInnerHTML: unsafeHTML(subtext) }),
                React.createElement("div", null,
                    React.createElement(Button, { buttonText: buttonText, buttonColor: buttonColor, buttonTextColor: buttonTextColor, buttonLink: buttonLink, buttonTarget: buttonTarget }))))));
};
export default CenterAlign;
